/**
 * Applies parsed forced decisions to an already-user-set Optimizely client.
 *
 * Must be called after optimizelyClient.setUser() - setForcedDecision()
 * silently no-ops if the SDK's internal user context doesn't exist yet.
 * See server/lib/optimizely/forcedDecisions.js for where these come from.
 *
 * @module lib/applyForcedDecisions
 */

/**
 * @param {Object} client - an Optimizely client that has already had setUser() called
 * @param {Array<{flagKey: string, variationKey: string}>} forcedDecisions
 * @param {Function} onError - called with (flagKey, error) if a single pair fails to apply
 */
export function applyForcedDecisions(client, forcedDecisions, onError) {
	if (!forcedDecisions?.length) {
		return;
	}

	for (const { flagKey, variationKey } of forcedDecisions) {
		try {
			client.setForcedDecision({ flagKey }, { variationKey });
		} catch (err) {
			onError?.(flagKey, err);
		}
	}
}
